import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full p-4" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex justify-center items-center -z-10"
}
const _hoisted_3 = {
  key: 1,
  class: "w-full overflow-y-auto flex flex-wrap gap-3 mb-20"
}

import Document from '@/interfaces/Document'
import { useSelectedProject } from '@/store/selectedProject'
import { Browser } from '@capacitor/browser'
import DocumentDiv from './DocumentDiv.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'ListOfDocuments',
  emits: ["setImageFullscreen"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'setImageFullscreen', v: Document): void
}), expose: any, slots: any, attrs: any }) {

const selectedProjectStore = useSelectedProject()

function openFile(document: Document) {
  Browser.open({ url: document.signed_url, windowName: document.file_name })
}



function setImageFullscreen(document: Document) {
  emits("setImageFullscreen", document)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(selectedProjectStore).documents && _unref(selectedProjectStore).documents.length <= 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Keine Dokumente gefunden "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedProjectStore).documents, (document, index) => {
            return (_openBlock(), _createBlock(DocumentDiv, {
              key: index,
              document: document,
              onOpenFile: ($event: any) => (openFile(document)),
              onShowFullscreen: ($event: any) => (setImageFullscreen(document))
            }, null, 8, ["document", "onOpenFile", "onShowFullscreen"]))
          }), 128))
        ]))
  ]))
}
}

})